import React, { useState, useEffect, useContext } from "react";
import {
  QueryClient,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";
import { CustomerContext } from "../CashierHomepage";
import { CustomerIdContext } from "../../context/CustomerIdProvider";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";

function CategoryProductCard({ item }) {
  const { createData } = CashierApi();
  const queryClient = useQueryClient();

  const { currency } = useContext(CustomerContext);
  const { selectedCustomerId } = useContext(CustomerIdContext);

  const [formData, setFormData] = useState({
    customer_id: [selectedCustomerId],
    product_id: item.id,
    price: item.price,
    quantity: 1,
  });

  useEffect(() => {
    setFormData((prev) => ({ ...prev, customer_id: selectedCustomerId }));
  }, [selectedCustomerId]);

  const handleClick = (e) => {
    e.preventDefault();
    mutation.mutate({ ...formData, title: "cart add" }, {});
  };

  const mutation = useMutation({
    mutationFn: (formData) => createData("carts/store", formData, true),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cart", selectedCustomerId] });
    },
  });
  return (
    <div
      onClick={handleClick}
      className="flex flex-col p-2 gap-3 bg-gray-200 hover:bg-gray-300 shadow-md items-center flex-none cursor-pointer rounded-md"
    >
      <ImageWithPlaceholder
        item={item}
        className="w-32 h-24 rounded-md object-cover"
        placeholderClassName="w-32 h-24 bg-slate-400 text-white flex justify-center font-medium items-center rounded-md text-5xl"
      />
      <div className="text-center">
        <h3 className="text-sm ">{item?.product_name}</h3>
        <h4 className="text-sm font-medium">
          {currency}
          {item?.price}
        </h4>
      </div>
    </div>
  );
}

export default React.memo(CategoryProductCard);
